<template>
  <div class="image-view">
    <tile-view
      v-if="viewMode === 'tile'"
      :images="images"
      :isCallByEditor="isCallByEditor"
      :isLogo="isLogo"
      @selectImage="selectImage"
      @deleteConfirm="$emit('deleteConfirm', $event)"
      @toggleSave="toggleSave"
      @toggleShowInput="toggleShowInput"
      @showImagePreview="showImagePreview"
      @showImageDetailEditor="showImageDetailEditor"
      ref="tile"
    />
    <list-view
      v-else
      :images="images"
      :isLogo="isLogo"
      @selectImage="selectImage"
      @deleteConfirm="$emit('deleteConfirm', $event)"
      @toggleSave="toggleSave"
      @toggleShowInput="toggleShowInput"
      @showImagePreview="showImagePreview"
      @showImageDetailEditor="showImageDetailEditor"
      ref="list"
    />
    <portal v-if="isShowImageDetailEditor" to="modal2">
      <image-detail-editor-popup
        :imageAttr="imageAttr"
        @reflectImage="$emit('getImages')"
        @close="isShowImageDetailEditor = false"
      />
    </portal>
    <portal v-if="preview.isShow" to="modal2">
      <image-preview
        :imageId="preview.imageId"
        @close="closeImagePreview"
      />
    </portal>
  </div>
</template>

<script>
import { validateImageFilename, validateImageAlt } from '@/utils/String'
import TileView from '@/components/ImageManager/ImageView/TileView'
import ListView from '@/components/ImageManager/ImageView/ListView'
import ImageDetailEditorPopup from '@/components/Util/ImageDetailEditor/ImageDetailPopup'
import ImagePreview from '@/components/Util/ImagePreview'

export default {
  props: [
    'viewMode',
    'images',
    'isCallByEditor',
    'isLogo',
  ],
  components: {
    TileView,
    ListView,
    ImageDetailEditorPopup,
    ImagePreview,
  },
  data () {
    return {
      isShowImageDetailEditor: false,
      imageAttr: null,
      isSelecting: false,
      preview: {
        isShow: false,
        imageId: null,
      },
    }
  },
  methods: {
    showImagePreview (image) {
      this.preview = {
        isShow: true,
        imageId: image.id,
      }
    },
    closeImagePreview () {
      this.preview = {
        isShow: false,
        imageId: null,
      }
    },
    selectImage (image) {
      if (this.isCallByEditor && !this.isSelecting) {
        // ダブルクリック防止
        this.isSelecting = true
        const formData = new FormData()
        formData.append('tmpUuid', this.$store.state.contentTmpUuid)
        formData.append('contentId', this.$route.params.id)
        formData.append('key', image.key)
        this.$http({
          url: '/image/add_content_image',
          type: 'POST',
          params: formData
        }).then(json => {
          if (json && json.status === 200) {
            let image = json.data.image
            image = { ...image, url: decodeURIComponent(image.url) }
            this.$store.commit('mergeContentImages', { [image.key]: image })
            this.$emit('reflectImage', image)
            this.isSelecting = false
          }
        })
      }
    },
    toggleSave (image, kind) {
      this.toggleShowInput(image, kind)
      this.$nextTick(() => {
        if (!image.showInput[kind]) {
          this.updateImageInfo(image, kind)
        }
      })
    },
    toggleShowInput (image, kind, index) {
      image.showInput[kind] = !image.showInput[kind]
      this.$nextTick(() => {
        if (image.showInput[kind]) {
          this.$refs[this.viewMode].$refs[kind + index][0].focus()
        }
      })
    },
    updateImageInfo (image, kind) {
      image.filename = String(image.filename).replace(/\r?\n/g, '')
      image.alt = String(image.alt).replace(/\r?\n/g, '')

      let errorMessages = [
        ...validateImageFilename(image.filename),
        ...validateImageAlt(image.alt)
      ]
      if (errorMessages.length > 0) {
        /**
         * 入力された画像のfilenameや alt の値が不正な場合
         * サーバーから画像データを再取得して表示されている値を元に戻す
         */
        this.$emit('getImages')
        return this.$store.commit('showErrorMessagePopup', errorMessages)
      }
      const formData = new FormData()
      formData.append('filename', this.$utils.string.b64Encode(image.filename))
      formData.append('alt', this.$utils.string.b64Encode(image.alt))
      formData.append('key', image.key)
      this.$http({
        url: '/image/update_info',
        type: 'POST',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          image.modifiedUserName = json.data.modifiedUserName
          image.modifiedOn = json.data.modifiedOn
        }
      })
    },
    showImageDetailEditor (image) {
      this.imageAttr = {
        alt: image.alt,
        'data-filename': image.filename,
        'data-filesize': image.filesize,
        'data-filetype': image.type,
        'data-height': image.height,
        'data-width': image.width,
        'data-key': image.key,
        src: image.url,
      }
      this.isShowImageDetailEditor = true
    },
  }
}
</script>
